import styled from 'styled-components'

const LikelihoodConsequenceRiskStyled = styled.div`
  display: flex;
  flex-direction: column;

  .likelihood-consequence-risk {
    &__grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 27px;
      width: 100%;
    }

    &__input-container {
      display: flex;
      flex-direction: column;
      min-width: 100%;
    }

    &__label {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: rgba(0, 0, 0, .85);
    }

    &__select {
      width: 100%;
    }

    &__risk-label {
      display: flex;
      align-items: center;
      margin-top: 18px;
    }

    &__risk-indicator {
      display: flex;
      margin-right: 6px;
      height: 20px;
      width: 20px;
      border-radius: 50%;

      &--low {
        background-color: #21ad37;
      }

      &--medium {
        background-color: #ffe834;
      }

      &--high {
        background-color: #fac560;
      }

      &--extreme {
        background-color: #ff1945;
      }
    }
  }
`

export default LikelihoodConsequenceRiskStyled
